module.exports = __webpack_public_path__ + "static/cad-designs1-a27378224a3806f832406ed3547b6a0b.png";